/**
 * Day One Performance — Tracking Signal Capture
 * Captures _fbc/_fbp cookies and UTM parameters into Shopify cart attributes
 * for server-side event enrichment (Meta CAPI, GA4 MP, Klaviyo).
 *
 * Runs once per session on first page load.
 */
(function() {
  'use strict';

  var STORAGE_KEY = 'd1_tracking_captured';
  var CART_UPDATE_URL = (window.theme && window.theme.routes && window.theme.routes.cartUpdate)
    || '/cart/update.js';

  // Only run once per session
  if (sessionStorage.getItem(STORAGE_KEY)) return;

  var attributes = {};

  // --- Task 3D: Capture Meta _fbc and _fbp cookies ---
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var c = cookies[i].trim();
    if (c.indexOf('_fbc=') === 0) {
      attributes['_fbc'] = c.substring(5);
    } else if (c.indexOf('_fbp=') === 0) {
      attributes['_fbp'] = c.substring(5);
    }
  }

  // Also capture fbclid from URL if _fbc cookie hasn't been set yet
  var urlParams = new URLSearchParams(window.location.search);
  if (!attributes['_fbc'] && urlParams.get('fbclid')) {
    // Build _fbc format: fb.1.{timestamp}.{fbclid}
    attributes['_fbc'] = 'fb.1.' + Date.now() + '.' + urlParams.get('fbclid');
  }

  // --- Task 6C: Capture UTM parameters ---
  var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  for (var j = 0; j < utmKeys.length; j++) {
    var val = urlParams.get(utmKeys[j]);
    if (val) {
      attributes[utmKeys[j]] = val;
    }
  }

  // Capture gclid (Google Ads click ID) if present
  if (urlParams.get('gclid')) {
    attributes['gclid'] = urlParams.get('gclid');
  }

  // Capture ttclid (TikTok click ID) if present
  if (urlParams.get('ttclid')) {
    attributes['ttclid'] = urlParams.get('ttclid');
  }

  // Only POST if we have something to send
  if (Object.keys(attributes).length === 0) {
    sessionStorage.setItem(STORAGE_KEY, '1');
    return;
  }

  fetch(CART_UPDATE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attributes })
  }).then(function() {
    sessionStorage.setItem(STORAGE_KEY, '1');
  }).catch(function() {
    // Silently fail — will retry next page load
  });
})();
